// // Function to initialize the cursor behavior
// const cursorBall = document.querySelector('.cursor__ball');
//
// // Update the position of the ball based on mouse cursor coordinates
// document.addEventListener('mousemove', (e) => {
//     cursorBall.style.left = `${e.clientX}px`;
//     cursorBall.style.top = `${e.clientY}px`;
// });